<script setup lang="ts">
    useSeoMeta({
        title: "勧誘方針｜株式会社Bang",
        description: "株式会社Bangの勧誘方針を掲載しています。",
        ogTitle: "勧誘方針｜株式会社Bang",
        ogDescription: "株式会社Bangの勧誘方針を掲載しています。",
        ogUrl: "https://www.bang-inc.jp/info/invite-policy",
    });

    const breadcrumbsItems = [
        { text: "トップページ", href: "/" },
        { text: "勧誘方針", href: "/info/invite-policy" },
    ];
</script>

<template>
  <main class="invite-policy">
    <!-- パンくずリスト -->
    <Breadcrumbs :items="breadcrumbsItems" />
    <div class="invite-policy__body">
    <HeadingCorp :level="1">勧誘方針</HeadingCorp>

    <section class="invite-policy__section">
        <HeadingCorp :level="2">第１章　総則</HeadingCorp>
        <div class="invite-policy__section-box">
            <HeadingCorp :level="3">１．目的・位置づけ</HeadingCorp>
            <p class="invite-policy__section-text">本方針は、「金融サービスの提供及び利用環境の整備等に関する法律」第９条に基づき、株式会社Bang（以下「当社」という。）が保険商品の勧誘を行うにあたって遵守すべき基本的な考え方および事項を定めるものである。</p>
            <p class="invite-policy__section-text">本方針は、当社が別途定める「比較推奨方針」および「お客さま本位の業務運営に関する方針」と一体のものとして運用し、用語・考え方に齟齬が生じないよう整合を図る。</p>
        </div>
        <div class="invite-policy__section-box">
            <HeadingCorp :level="3">２．適用範囲（対象チャネル）</HeadingCorp>
            <p class="invite-policy__section-text">本方針は、当社が行う保険商品の勧誘の全てのチャネルに適用する。</p>
            <ul>
                <li class="invite-policy__definition-item">1. WEBチャネル：当社WEBサイトを通じた通信販売による勧誘（現行実施）</li>
                <li class="invite-policy__definition-item">2. コールセンターチャネル：電話等による意向把握・意向確認およびアポイントメント取得を伴う勧誘（今後整備）</li>
                <li class="invite-policy__definition-item">3. 共同募集チャネル：当社によるアポイントメント取得を前提に、提携代理店が対面・電話等により行う勧誘（今後整備）</li>
            </ul>
        </div>
    </section>

    <section class="invite-policy__section">
        <HeadingCorp :level="2">第２章　勧誘に関する基本方針</HeadingCorp>
        <ul class="invite-policy__dot-list">
            <li class="invite-policy__dot-item">・法令等の遵守：保険業法、金融サービスの提供及び利用環境の整備等に関する法律、消費者契約法、特定商取引法その他関連法令等を遵守し、適正な勧誘を行う。</li>
            <li class="invite-policy__dot-item">・お客さまの意向、実情に応じた勧誘：お客さまの年齢、知識・経験、資産の状況、契約締結の目的等に照らして適正な商品説明を行い、実情に適合しない勧誘は行わない。</li>
            <li class="invite-policy__dot-item">・誤認防止：お客さまに対し、保険商品に関する重要事項を十分に説明し、将来の利益を保証するような誤解を招く説明や事実と異なる説明は行わない。</li>
            <li class="invite-policy__dot-item">・商品特性の説明：保険商品と預金その他の金融商品との違いについても、分かりやすく説明するよう努める。</li>
            <li class="invite-policy__dot-item">・体制整備：適正な勧誘を行うため、勧誘に携わる者への指導・研修、事務管理体制の整備に努める。</li>
        </ul>
    </section>

    <section class="invite-policy__section">
        <HeadingCorp :level="2">第３章　勧誘の適正確保に関する事項</HeadingCorp>
        <div class="invite-policy__section-box">
            <HeadingCorp :level="3">１．勧誘主体の明示</HeadingCorp>
            <ul class="invite-policy__dot-list">
                <li class="invite-policy__dot-item">・電話・WEB・書面のいずれの方法による場合も、勧誘の開始にあたり、当社の商号（株式会社Bang）、担当者名（コールセンターの場合は氏名または管理番号）、当社の保険募集業務として連絡している旨、および当社が保険募集人である旨を明示する。</li>
                <li class="invite-policy__dot-item">・提携代理店が募集を行う場合は、当該提携代理店の商号および当社との関係（アポイントメントの引継ぎ元である旨）をお客さまに明示する。</li>
            </ul>
        </div>
        <div class="invite-policy__section-box">
            <HeadingCorp :level="3">２．電話勧誘の時間帯・方法への配慮</HeadingCorp>
            <ul class="invite-policy__dot-list">
                <li class="invite-policy__dot-item">・コールセンターからの架電は、お客さまにご迷惑をおかけしない時間帯（一般的な生活時間帯を踏まえ、早朝・深夜を避ける等）に行う。お客さまから架電を希望されない時間帯の申出があった場合は、当該時間帯を避けて対応する。</li>
                <li class="invite-policy__dot-item">・お客さまのご都合により、架電日時の変更・再連絡の希望があった場合は、これに応じる。</li>
            </ul>
        </div>
        <div class="invite-policy__section-box">
            <HeadingCorp :level="3">３．勧誘を受ける意思の確認・再勧誘の禁止</HeadingCorp>
            <ul class="invite-policy__dot-list">
                <li class="invite-policy__dot-item">・勧誘に先立ち、お客さまに対し勧誘を受ける意思の有無を確認するよう努める。</li>
                <li class="invite-policy__dot-item">・お客さまから明示的に契約締結の意思がない旨の表示があった場合は、当該お客さまに対する再度の勧誘を行わない。</li>
                <li class="invite-policy__dot-item">・法令上認められる範囲で行う契約保全に関する案内その他のお客さまサービスに関する連絡については、この限りではない。</li>
            </ul>
        </div>
        <div class="invite-policy__section-box">
            <HeadingCorp :level="3">４．なりすまし対策・本人確認</HeadingCorp>
            <ul class="invite-policy__dot-list">
                <li class="invite-policy__dot-item">・コールセンターでのご案内にあたっては、お客さまが安心して対応いただけるよう、当社担当者であることの確認手段（折り返し電話番号のご案内等）を用意する。</li>
                <li class="invite-policy__dot-item">・お客さまの契約内容に関する照会に対応する際は、必要な範囲で本人確認を行う。</li>
            </ul>
        </div>
    </section>

    <section class="invite-policy__section">
        <HeadingCorp :level="2">第４章　特に配慮を要するお客さまへの対応</HeadingCorp>
        <div class="invite-policy__section-box">
            <HeadingCorp :level="3">１．ご高齢のお客さま</HeadingCorp>
            <p class="invite-policy__section-text">保険会社の高齢者募集ルールを踏まえ、満70歳以上のお客さまその他特に配慮を要するお客さまを契約者とする保険契約等については、より分かりやすく丁寧な説明を心がけ、必要に応じてご家族等の同席や、契約前に十分検討いただく期間の確保等、きめ細かな対応に努める。</p>
        </div>
        <div class="invite-policy__section-box">
            <HeadingCorp :level="3">２．障がいのあるお客さま</HeadingCorp>
            <p class="invite-policy__section-text">障がいの内容・特性に応じた合理的配慮を行うよう努める。合理的配慮の実施に伴う負担が過重である場合には、お客さまとの対話を通じて相互理解に努め、可能な範囲での対応を行う。</p>
        </div>
        <div class="invite-policy__section-box">
            <HeadingCorp :level="3">３．未成年者を被保険者とする場合</HeadingCorp>
            <p class="invite-policy__section-text">未成年者を被保険者とする保険契約の勧誘にあたっては、保護者の同意状況等を確認のうえ、特に配慮して対応する。</p>
        </div>
    </section>

    <section class="invite-policy__section">
        <HeadingCorp :level="2">第５章　共同募集（提携代理店との連携）における勧誘方針</HeadingCorp>
        <div class="invite-policy__section-box">
            <HeadingCorp :level="3">１．勧誘主体の明確化</HeadingCorp>
            <p class="invite-policy__section-text">当社がコールセンターにおいて意向把握・意向確認およびアポイントメントの取得を行い、契約締結に向けた募集実務（契約締結の媒介・代理、告知受領等）を提携代理店が行う場合、お客さまに対し、勧誘の各段階でどの事業者が何を行っているかを明確に説明する。</p>
            <ul>
                <li class="invite-policy__definition-item">1. 当社による対応段階：意向把握・意向確認、アポイントメントの取得</li>
                <li class="invite-policy__definition-item">2. 提携代理店による対応段階：契約締結に向けた最終的な説明、告知受領、契約手続き</li>
            </ul>
        </div>
        <div class="invite-policy__section-box">
            <HeadingCorp :level="3">２．重複勧誘・説明齟齬の防止</HeadingCorp>
            <ul class="invite-policy__dot-list">
                <li class="invite-policy__dot-item">・当社が把握したお客さまの意向・ご事情を提携代理店に正確に引継ぎ、同一内容について不必要に重ねて確認することのないよう配慮する。</li>
                <li class="invite-policy__dot-item">・当社と提携代理店との間で、勧誘方針・比較推奨方針の考え方に齟齬が生じないよう、定期的な情報連携・研修を行う。</li>
            </ul>
        </div>
        <div class="invite-policy__section-box">
            <HeadingCorp :level="3">３．お客さまへの事前説明</HeadingCorp>
            <ul class="invite-policy__dot-list">
                <li class="invite-policy__dot-item">・アポイントメント取得の際、今後のご案内は提携代理店が行うこと、提携代理店の担当者名・連絡先をあらかじめお伝えする。</li>
                <li class="invite-policy__dot-item">・お客さまが引継ぎ後の対応を望まれない場合は、その意思を尊重し、無理な勧誘は行わない。</li>
            </ul>
        </div>
    </section>

    <section class="invite-policy__section">
        <HeadingCorp :level="2">第６章　情報を収集する目的</HeadingCorp>
        <div class="invite-policy__section-box">
            <HeadingCorp :level="3">１．通信販売（インターネット・電子メール・ダイレクトメール）</HeadingCorp>
            <ul class="invite-policy__dot-list">
                <li class="invite-policy__dot-item">・お客さまにとって分かりやすく、見やすく、安心してご利用いただけるよう、保険販売に関する重要事項の説明ならびに商品内容に関する有益な情報の提供に努める。</li>
                <li class="invite-policy__dot-item">・電子メール・ダイレクトメールの発送、電話による勧誘・確認においても、お客さまのご都合・ご事情に応じた適切な方法で行う。</li>
            </ul>
        </div>
        <div class="invite-policy__section-box">
            <HeadingCorp :level="3">２．コールセンターにおける情報収集</HeadingCorp>
            <ul class="invite-policy__dot-list">
                <li class="invite-policy__dot-item">・意向把握・意向確認の過程で収集した情報は、お客さまへの適切なご案内および比較推奨方針に定める推奨理由の説明のために利用し、目的外の利用は行わない。</li>
            </ul>
            <p class="invite-policy__section-text">お客さまの様々なご意見の収集に努め、その後の販売活動に活かすとともに、説明方法等に工夫を凝らし、お客さまにご理解いただけるよう努める。</p>
        </div>
    </section>

    <section class="invite-policy__section">
        <HeadingCorp :level="2">第７章　お客さま情報の取扱い</HeadingCorp>
        <ul class="invite-policy__dot-list">
            <li class="invite-policy__dot-item">・個人情報保護の観点から、お客さまに関する情報管理を的確に実行する。</li>
            <li class="invite-policy__dot-item">・インターネットにおいても、お客さまの情報に対する不正なアクセスを防止するため、ファイアウォールシステムを導入するとともに、情報伝達の際にはSSL等の暗号化を行う。</li>
            <li class="invite-policy__dot-item">・提携代理店へお客さまの情報を引き継ぐ場合は、必要な範囲に限定し、提携契約に基づく適正な管理のもとで行う。</li>
        </ul>
    </section>

    <section class="invite-policy__section">
        <HeadingCorp :level="2">第８章　各種サービス体制</HeadingCorp>
        <p class="invite-policy__section-text">保険契約について、万が一保険事故が発生した場合は、</p>
        <ul class="invite-policy__dot-list">
            <li class="invite-policy__dot-item">・個人情報保護法その他関係法令を遵守し、法令に基づく同意取得その他必要な措置を講じたうえで、必要な範囲に限定して行う。</li>
        </ul>
        <p class="invite-policy__section-text">また、提供先においても適切な安全管理措置が講じられるよう必要な管理を行う。</p>
        <ul class="invite-policy__dot-list">
            <li class="invite-policy__dot-item">・通信販売を通じてご契約いただいたお客さまについても、保険事故発生時に備え、適切な対処方法、事故受付センター等の事故処理窓口、その他有益な情報を分かりやすく提供できるよう努める。</li>
            <li class="invite-policy__dot-item">・お客さまからのご意見、ご要望および苦情等については、誠実かつ迅速な対応に努めるとともに、その内容を踏まえ業務品質の向上および再発防止に努める。</li>
        </ul>
    </section>

    <section class="invite-policy__section">
        <HeadingCorp :level="2">第９章　教育・研修体制の整備</HeadingCorp>
        <p class="invite-policy__section-text">当社は、本方針に沿った適正な勧誘が行われるよう、勧誘に携わる者（コールセンター担当者を含む。）に対する定期的な研修を実施し、理解度の確認を行う。あわせて、提携代理店に対しても、本方針および比較推奨方針の考え方について必要な情報提供・連携を行う。</p>
    </section>

    <section class="invite-policy__section">
        <HeadingCorp :level="2">【個人情報の取扱事業者・お問い合わせ窓口】</HeadingCorp>
        <p class="invite-policy__section-text">
            お客さまからのご意見・ご要望・苦情等については、誠実かつ迅速に対応し、再発防止および業務改善に努めます。<br>
            株式会社Bang　カスタマーサービスセンター<br>
            受付時間　午前10時00分～午後6時00分（土曜・日曜・祝日・年末年始除く）<br>
            e-mail：<a href="mailto:info@bang-inc.jp">info@bang-inc.jp</a><br><br>
        </p>
        <p class="invite-policy__section-text">
            制定日：2025年8月18日<br>
            改定日：2026年10月1日<br>
            株式会社Bang　代表取締役　長山　真己
        </p>
    </section>
    </div>
  </main>
</template>

<style scoped lang="scss">
.invite-policy {
    position: relative;
    width: min(91vw, 64.5rem);
    margin: auto;
    &::before {
        content: '';
        position: absolute;
        width: 20rem; // 320px
        height: 20rem; // 320px
        aspect-ratio: 1/1;
        left: -4rem; // -64px
        top: -3rem; // -48px
        border-radius: 20rem; // 320px
        box-sizing: border-box;
        border: 1.5rem solid #EFF7FF; // 24px
        z-index: -1; // コンテンツの背景に配置
        pointer-events: none; // クリックイベントを通す
    }
    &__body {
        padding: 2rem 0 4.5rem;
    }
    &__section {
        line-height: 150%;
        &:not(:last-child) {
            margin-bottom: 2.5rem;
        }
        a[href] {
            color: #2174C0;
            text-decoration: underline;
            overflow-wrap: anywhere;
            &:hover {
                opacity: 0.48;
                transition: opacity 0.3s ease;
            }
        }
    }
    &__section-box {
        &:not(:last-child) {
            margin-bottom: 1rem;
        }
    }
    &__section-text {
        &:not(:last-child) {
            margin-bottom: 0.25rem;
        }
    }
    &__dot-list {
        margin-bottom: 0.25rem;
    }
    &__dot-item {
        margin-bottom: 0.25rem;
        text-indent: -1rem;
        padding-left: 1rem;
    }
    &__definition-item {
        margin-bottom: 0.5rem;
        text-indent: -1.2rem;
        padding-left: 1.2rem;
    }
}


@include mixin.media(pc) {
    .invite-policy {
        &::before {
            width: 32.5rem; // 520px
            height: 32.5rem; // 520px
            left: -10.7rem; // -171.2px
            top: -4rem; // -64px
            border-radius: 32.5rem; // 520px
            border: 2.5rem solid #EFF7FF; // 24px
        }
        &__body {
            padding: 4rem 0 5rem;
        }
        &__section {
            &:not(:last-child) {
                margin-bottom: 3rem;
            }
        }
    }
}
</style>
